<template>
  <div class="hot-container">
    <navbar active="hot" />
    <list />

    <back-to-top :custom-style="myBackToTopStyle" :visibility-height="300" :back-position="0" transition-name="fade" />
  </div>
</template>
<script>
  import Navbar from '../../common/components/Navbar'
  import BackToTop from '../../common/components/BackToTop'
  import List from './List'
  export default {
    components: { Navbar, List, BackToTop },
    data() {
      return {
        // customizable button style, show/hide critical point, return position
        myBackToTopStyle: {
          right: '10px',
          bottom: '60px',
          width: '40px',
          'border-radius': '4px'
        }
      }
    }
  }
</script>
<style lang="less" scoped>
@import "../css/index";
</style>
